import { Injectable, OnInit } from '@angular/core';
import { FCM } from 'cordova-plugin-fcm-with-dependecy-updated/ionic';
import { Device } from '@ionic-native/device/ngx';
// import { Data } from './DataService';
import { HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ProvidehttpService } from './providehttp.service';
//import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
// import { MobileService } from './mobile.services';
// import { RetailStock } from './retail-common.service';

declare var window: any;
declare var cordova: any;

@Injectable({
  providedIn: 'root'
})
export class FcmNotificationService {
  protected _token: string;
  fcmToken: string;
  isRemoteNotificationsEnabled: boolean = false;
  constructor(
    protected device: Device,
    // protected dataservice: Data,
    //private spinnerService: Ng4LoadingSpinnerService,
    public http: ProvidehttpService,
    public router: Router,
    // public mobile: MobileService,
    // public dataStore: Data,
    // private retailStock:RetailStock
  ) {
    this.fcmToken = "";
    if(window["cordova"]){
      FCM?.getToken()?.then((token?:any)=>{
        this.fcmToken=token;
      });
    }

  }

  async checkFCMPermission() {
    if (!window["cordova"]) return;

    // this.isRemoteNotificationsEnabled = await FCM.hasPermission();
    // if (this.isRemoteNotificationsEnabled) {
    //   this.listenNotification();
    // }

    const hasPermission = await FCM.hasPermission();
    if (!hasPermission) {
      const wasPermissionGiven = await FCM.requestPushPermission();
      if (wasPermissionGiven) {
        this.isRemoteNotificationsEnabled = true;
        this.listenNotification();
        return true;
      } else {
        this.isRemoteNotificationsEnabled = false;
        return false;
      }
    } else {
      this.listenNotification();
      return true;
    }
  }
  // async updateToken() {
  //   if(!this.mobile.isHybrid()) return;

  //   this.fcmToken = await FCM.getToken();
  //   this.isRemoteNotificationsEnabled = await FCM.hasPermission();
  //   if (this.isRemoteNotificationsEnabled) {
  //     let inputMap = new Map();
  //     let obj = {};
  //     obj["fcmtoken"] = {};
  //     obj["fcmtoken"]["token"] = this.fcmToken;
  //     inputMap.clear();
  //     inputMap.set("PathParam.customerCode", sessionStorage.getItem("customerCode"));
  //     inputMap.set("PathParam.deviceId", this.mobile.deviceID);
  //     inputMap.set("Body", obj);
  //     //this.spinnerService.show();
  //     this.http.fetchApi("/fcmtoken/{customerCode}/{deviceId}", "PUT", inputMap, this.retailStock.getEnvironment().customersPublisher).subscribe(
  //       async (httpResponse: HttpResponse<any>) => {
  //         //this.spinnerService.hide();
  //         console.log("FCM token updated");
  //       },
  //       async (httpError) => {
  //         //this.spinnerService.hide();
  //         console.log("FCM token not updated");
  //         var err = httpError["error"];
  //         if (err != null && err["ErrorElementPath"] != undefined && err["ErrorDescription"] != undefined) {
  //         }
  //       }
  //     );
  //   }

  // }
  getFcmToken() {
    return this.fcmToken;
  }

  async requestPushNotificationPermission(): Promise<boolean>{
    const hasPermission = await FCM.hasPermission();
    if (!hasPermission) {
      const wasPermissionGiven = await FCM.requestPushPermission();
      if (wasPermissionGiven) {
        this.isRemoteNotificationsEnabled = true;
        this.listenNotification();
        return true;
      } else {
        this.isRemoteNotificationsEnabled = false;
        return  false;
      }
    }else{
      return  false;
    }
  };

  async requestPushNotificationPermission1() {
    const hasPermission = await FCM.hasPermission();
    if (!hasPermission) {
      const wasPermissionGiven = await FCM.requestPushPermission();
      if (wasPermissionGiven) {
        this.isRemoteNotificationsEnabled = true;
        this.listenNotification();
        return true;
      } else {
        this.isRemoteNotificationsEnabled = false;
        return false;
      }
    }
  }

  listenNotification() {
    console.log("push notification triggered and watching");
    FCM.onNotification().subscribe(data => {
      console.log("notification subscribed");
      // this.showRewardScreen(data);
      cordova.plugins.notification.local.schedule({
        title: data.title,
        text: data.body,
        foreground: true
    });
    });
  }
  // showRewardScreen(data) {
  //   this.dataStore.setPushPayload(data);
  //   sessionStorage.setItem("notificationOn", "true");
  //   if (this.dataStore.isUserLoggedIn()) {
  //     this.router.navigate(['/home/redeem']);
  //     sessionStorage.removeItem("notificationOn");
  //   }
  //   else {
  //     if (this.mobile.isFaceIDAvailable && localStorage.getItem("faceId")) {
  //       this.router.navigate(["/welcome/", "faceidlogin"]);
  //     }
  //     else {
  //       console.log("logged in with mpin");
  //       this.router.navigate(["/welcome/", "mpinlogin"]);
  //     }
  //   }
  // }
  callbackHandler: any;
  async checkPushPayload(event) {
    if (event) this.callbackHandler = event;
    let wasTapped = sessionStorage.getItem("wasTapped") || "";
    const pushPayload: object = await FCM.getInitialPushPayload();
    if (pushPayload && pushPayload != null && !wasTapped) {
    	sessionStorage.setItem("wasTapped", "true");

      setTimeout(() => {
        (<any>window).navigator.splashscreen.hide();
        setTimeout(() => {
          // this.showRewardScreen(pushPayload);
          this.callbackHandler(true);
        }, 100);
      }, 100);
    }
    else {
      this.callbackHandler(false);
    }
  }
}
